import { render, staticRenderFns } from "./telepresenceNotes.vue?vue&type=template&id=9216a6c2"
import script from "./telepresenceNotes.vue?vue&type=script&lang=js"
export * from "./telepresenceNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports